module.exports = __webpack_public_path__ + "assets/7fde53b150c952363f7cfcbf18a85e06.mp3";